/** Re-export shared promotion engine (POS + online). */
export {
  evaluateCart,
  isLineEligibleForAutoPromo,
  isPromotionScheduleActive,
  promotionAppliesToBranch,
  promotionAppliesToChannel,
  promotionMatchesLine,
  buildTargetsByPromotionId,
  sortPromotionsForEvaluation,
  estimatePromotionBenefit,
  checkPromotionConditions,
} from '@shared/promotions/promotionEngine';
